import { Helmet } from 'react-helmet';
import { RadioOptionsWithConfirm } from 'shared-components';
import QuestionPage from '../../../templates/question';
import { Q } from '../../../../store/student/types';
import { ConfigField } from '../../../../types';
import { titleAppend } from '../../../../utilities/head';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import {
  createNavigateForwardAction,
  createNavigateBackwardAction,
  createNavigateToAction
} from '../../../../middleware/actions';
import * as StudentActions from '../../../../store/student/actions';
import * as OfferActions from '../../../../store/student/offer/actions';
import { toggleTaskMenu } from '../../../../store/ui/actions';
import { Pages } from '../../../../store/student/personalInfo/types';
import { useCallback, useEffect } from 'react';
import { ListItem, UnorderedList, Text, Box } from '@chakra-ui/react';

const PersonalQPage8 = () => {
  // dispatch actions
  const dispatch = useDispatch();

  const onPrevious = () => dispatch(createNavigateBackwardAction());
  const onNext = (config: any) => {
    dispatch(StudentActions.savePersonalInfo(Pages.PAGE9, config));
    dispatch(createNavigateForwardAction());
  };
  const onSkip = () => dispatch(createNavigateForwardAction());
  const onChange = useCallback(
    (fieldName: string, value: any) => dispatch(OfferActions.createUpdateOfferFieldAction(fieldName, value)),
    [dispatch]
  );
  const onBackToTaskList = () => {
    dispatch(createNavigateToAction('/dashboard'));
    dispatch(toggleTaskMenu(false));
  };
  // state vars
  const { VisaSupport: visaSupportConfig }: { VisaSupport: ConfigField } = useSelector(
    ({ config }: ApplicationState) => config.Checklist.PersonalInfo.Page9
  );
  const { visaSupport = visaSupportConfig?.defaultValue } = useSelector(
    ({ student }: ApplicationState) => student.offer
  );
  const config = useSelector(({ config }: ApplicationState) => config);
  const sectionTitle = useSelector(({ config }: ApplicationState) => config.Checklist.PersonalInfo.shortTitle);
  const currentStep = 9;
  const steps = 10;

  // prettier-ignore
  const complete = visaSupport !== undefined;

  const handleVisaSupportClick = useCallback(
    question => {
      onChange(Q.VISA_SUPPORT, question.char === 'Y' ? true : false);
    },
    [onChange]
  );

  return (
    <QuestionPage
      complete={complete}
      currentStep={currentStep}
      steps={steps}
      onNext={() => onNext(config)}
      onSkip={onSkip}
      onPrevious={onPrevious}
      onBackToTaskList={onBackToTaskList}
      section={sectionTitle}
    >
      <Helmet>
        <title>
          {`${sectionTitle}: Step ${currentStep}`} {titleAppend}
        </title>
      </Helmet>

      <RadioOptionsWithConfirm
        key={Q.VISA_SUPPORT}
        id={Q.VISA_SUPPORT}
        label={visaSupportConfig?.label}
        subText={
          <Box>
            <Text>Our team is here to help, with free guidance and support every step of the way.</Text>
            <UnorderedList>
              <ListItem>Expert Support: Ask questions about your application.</ListItem>
              <ListItem>Document Checks: Ensure you meet the requirements.</ListItem>
              <ListItem>Interview Preparation: Get tailored advice.</ListItem>
              <ListItem>Application Assistance: Get step-by-step help.</ListItem>
            </UnorderedList>
          </Box>
        }
        inputHelperText={visaSupportConfig?.helpText}
        autofocus={true}
        onClick={(question: any) => handleVisaSupportClick(question)}
        isInline={true}
        questionMaxWidth={220}
        maxQuestions={2}
        questions={[
          {
            char: 'Y',
            label: 'Yes',
            selected: visaSupport === true
          },
          {
            char: 'N',
            label: 'No',
            selected: visaSupport === false
          }
        ]}
      />
    </QuestionPage>
  );
};

export default PersonalQPage8;
